import { Component } from 'react'
import PropTypes from 'prop-types'

export default class Label extends Component {
  render() {
    const { children, htmlFor, className } = this.props
    return (
      <label htmlFor={htmlFor} className={className}>
        {children}
      </label>
    )
  }
}
Label.propTypes = {
  htmlFor: PropTypes.string,
  className: PropTypes.string,
}
Label.defaultProps = {
  className: null,
  htmlFor: null,
}
